<div class="collection-info">
  <ng-container *ngIf="!!data || !!loading || mode === 'create'; else collectionNotFounded">
    <lp-collection-info-header
      [id]="data?.id"
      [title]="data?.title"
      [unionId]="unionId"
      [allowCollectionStatisticsViewing]="allowedCollectionStatisticsViewing"
      [mode]="mode"
      (cancelEdit)="onClickCancelButton()"
    ></lp-collection-info-header>

    <tui-scrollbar>
      <div class="collection-info__content">
        <lp-collection-view
          *ngIf="mode === 'view'"
          [data]="data"
          [ref]="ref"
          [allowEditing]="allowEditing$ | async"
          [allowDeleting]="allowDeleting$ | async"
          [loading]="loading"
          (edit)="onClickEditButton.emit()"
          (delete)="onClickDeleteButton()"
        ></lp-collection-view>

        <lp-collection-edit
          *ngIf="mode === 'edit' || mode === 'create'"
          [data]="data"
          [mode]="mode"
          [loading]="loading"
          [unionId]="unionId"
          (saveCollection)="onClickSaveButton($event)"
          (cancelEdit)="onClickCancelButton()"
          (checkPush)="onCheckPush()"
        ></lp-collection-edit>
      </div>
    </tui-scrollbar>
  </ng-container>
</div>

<ng-template #collectionNotFounded>
  <div class="collection-info__not-found">
    <span class="text_bold text_size-m">{{ 'components.lpCollectionInfo.labels.collectionNotFound' | translate }}</span>

    <app-link
      [routerLink]="'/loyalty'"
      [displayText]="'components.loyaltyProgram.buttons.homeLink' | translate"
    ></app-link>
  </div>
</ng-template>
